import { render } from "./ProfileMenu.vue?vue&type=template&id=5091216b&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=5091216b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5091216b"

export default script